import Skeleton from "./Skeleton";

interface ProjectTableSkeletonProps {
  count?: number;
}

const ProjectTableSkeleton = ({ count = 4 }: ProjectTableSkeletonProps) => (
  <div className="plist table-responsive">
    <table className="table">
      <thead>
        <tr className="chdr">
          <th>Project ↑</th>
          <th>Status</th>
          <th>Progress</th>
          <th>Bank / Draws</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: count }).map((_, i) => (
          <tr key={i} className="prow">
            <td>
              <div className="pc">
                <Skeleton
                  variant="card"
                  width={42}
                  height={42}
                  borderRadius="4px"
                  style={{ flexShrink: 0 }}
                />
                <div
                  className="pi"
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <Skeleton width={150} height={13} />
                  <Skeleton width={210} height={11} />
                </div>
              </div>
            </td>
            <td>
              <div
                className="sc"
                style={{ display: "flex", flexDirection: "column", gap: 6 }}
              >
                <Skeleton width={96} height={22} borderRadius={12} />
                <Skeleton width={80} height={11} />
              </div>
            </td>
            <td>
              <div
                className="pgc"
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                <Skeleton width={90} height={6} borderRadius={3} />
                <Skeleton width={30} height={11} />
              </div>
            </td>
            <td>
              <div
                className="bnk"
                style={{ display: "flex", flexDirection: "column", gap: 5 }}
              >
                <Skeleton width={90} height={13} />
                <Skeleton width={70} height={11} />
              </div>
            </td>
            <td>
              <div className="ac" style={{ display: "flex", gap: 6 }}>
                <Skeleton width={78} height={28} borderRadius={4} />
                <Skeleton width={104} height={28} borderRadius={4} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ProjectTableSkeleton;
